import { parseLocaleNumber } from "./decimal";

const DROP_TOKENS = new Set([
  "stuck",
  "stueck",
  "stuk",
  "stk",
  "piece",
  "pieces",
  "pc",
  "pcs",
  "ml",
  "cl",
  "dl",
  "l",
  "liter",
  "kg",
  "g",
  "gr",
  "mg",
  "klein",
  "gross",
  "gro",
  "small",
  "large",
]);

export function normalizeProductSalesName(value) {
  const normalized = String(value || "")
    .trim()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ß/g, "ss")
    .replace(/ẞ/g, "SS")
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .trim()
    .toLowerCase();

  return normalized
    .split(/\s+/)
    .map((token) => token.replace(/^\d+(?:[.,]\d+)?$/, ""))
    .filter((token) => token && !DROP_TOKENS.has(token))
    .join(" ");
}

export function productSalesNamesMatch(left, right) {
  const leftKey = normalizeProductSalesName(left);
  return !!leftKey && leftKey === normalizeProductSalesName(right);
}

export function lineItemMatchesRecipe(lineItem, recipe) {
  if (!lineItem || !recipe) return false;
  if (lineItem.external_pos_id && recipe.external_pos_id) {
    return lineItem.external_pos_id === recipe.external_pos_id;
  }
  return productSalesNamesMatch(lineItem.name, recipe.name);
}

export function countRecipeUnitsSold(recipe, sales) {
  return (sales || []).reduce((total, sale) => {
    let saleTotal = total;
    if (Array.isArray(sale.line_items)) {
      sale.line_items.forEach((lineItem) => {
        if (lineItemMatchesRecipe(lineItem, recipe)) {
          saleTotal += parseLocaleNumber(lineItem.quantity, 0);
        }
      });
    }
    if (Array.isArray(sale.items_sold)) {
      sale.items_sold.forEach((item) => {
        if (item.recipe_id === recipe.id || productSalesNamesMatch(item.recipe_name, recipe.name)) {
          saleTotal += parseLocaleNumber(item.quantity, 1);
        }
      });
    }
    return saleTotal;
  }, 0);
}
